const genericReducer = (state, newState) => ({
  ...state,
  ...newState,
});

export default genericReducer;
